<template>
  <div v-if="speakingData">
    <p class="text-2xl font-bold text-center mb-4" v-if="selectedStep === 1 && currentPartQuestions?.NameEn && !isToeic && currentPhase !== 'direction' && currentPhase !== 'preContinue'">{{ currentPartQuestions.NameEn }}</p>
    <p class="font-bold text-xl" v-if="isToeic && selectedStep === 1 && currentPhase !== 'direction' && currentPhase !== 'finish' && currentPhase !== 'preContinue'">Question {{ currentPartQuestions.Questions[currentQuestionIndex].Num }} <span v-if="isToeic">of 11</span></p>
    <div class="bg-white w-100 h-100 p-2 p-md-4 speaking_inner mb-2 d-flex justify-content-center mb-3">
      <div v-if="selectedStep === 0">
        <!-- <span class="mr-2">Part</span><input type="number" :max="speakingData.length - 1" min="0" v-model="currentPart" v-if="selectedStep === 0"> -->
        <Precautions />
      </div>

      <div v-if="selectedStep === 1" class="w-100 h-100">
        <bridge_direction v-if="currentPhase === 'preContinue' && !isToeic" />

        <div v-if="(isDirection && isToeic) || (isDirection && !isToeic && currentPart === 2)" class="w-100 h-100 mx-auto">
          <p class="max-w-3xl mx-auto text-2xl text-center mb-4" v-if="currentPartQuestions?.NameEn">{{ currentPartQuestions?.NameEn }}</p>
          <p class="currentPartQuestions_Description max-w-3xl mx-auto text-lg text-left" v-if="currentPartQuestions?.Description" v-html="currentPartQuestions.Description.replace(/(?:\r\n|\r|\n)/g, '<br/>')"></p>
          <p class="stemQuestionsWords max-w-3xl mx-auto text-lg text-left" v-if="currentPartQuestions.stemQuestionsWords && ((!isToeic && isDirection) || (isToeic && (currentPart !== 2 && isDirection)))" v-html="currentPartQuestions.stemQuestionsWords.replace(/(?:\r\n|\r|\n)/g, '<br/>')"></p>
          <div class="Description py-3" v-if="(isDirection && !isToeic && (currentPart === 0 || currentPart === 2)) && currentPartQuestions.Questions[currentQuestionIndex]?.Description">
            <p class="max-w-3xl mx-auto text-lg text-left" v-html="currentPartQuestions.Questions[currentQuestionIndex].Description.replace(/(?:\r\n|\r|\n)/g, '<br/>')"></p>
          </div>
        </div>
        <div v-if="(currentPhase !== 'direction' && currentPhase !== 'finish' && currentPhase !== 'isLoadingReport' && currentPhase !== 'preContinue') || (isDirection && !isToeic && currentPart !== 2)">
          <p class="text-xl" v-if="!isToeic && currentPhase !== 'direction'">Question {{ currentPartQuestions?.Questions[currentQuestionIndex].Num }}</p>
          <p class="text-2xl text-center mb-4" v-if="currentPartQuestions?.NameEn && !isToeic && (!isToeic && currentPart !== 2) && isDirection">{{ currentPartQuestions.NameEn }}</p>
          <div class="py-3" v-if="(!isToeic && currentPart !== 2 && isDirection) && currentPartQuestions.Description">
            <p class="currentPartQuestions_Description text-left mb-0 text-lg max-w-3xl mx-auto" v-html="currentPartQuestions.Description.replace(/(?:\r\n|\r|\n)/g, '<br/>')"></p>
          </div>
          <p class="Description max-w-3xl mx-auto text-lg text-left" v-if="(!isToeic && (currentPhase === 'prepare' || currentPhase === 'response') && currentPart === 5) || (isToeic&& (currentPart !== 1 && currentPart !== 3)) && currentPartQuestions.Questions[currentQuestionIndex].Description" v-html="currentPartQuestions.Questions[currentQuestionIndex].Description.replace(/(?:\r\n|\r|\n)/g, '<br/>')"></p>
          <p class="stemQuestionsWords max-w-3xl mx-auto text-lg text-left" v-if="currentPartQuestions.stemQuestionsWords && ((!isToeic && isDirection && currentPart !== 2) || (!isToeic && !isDirection && currentPart === 5) || (isToeic))" v-html="currentPartQuestions.stemQuestionsWords.replace(/(?:\r\n|\r|\n)/g, '<br/>')"></p>
          <p class="Title max-w-3xl mx-auto text-lg text-left" v-if="isToeic && currentPartQuestions.Questions[currentQuestionIndex].Title" v-html="currentPartQuestions.Questions[currentQuestionIndex].Title.replace(/(?:\r\n|\r|\n)/g, '<br/>')"></p>
          <p class="Description max-w-3xl mx-auto text-lg text-left" v-if="(!isToeic && (currentPhase === 'prepare' || currentPhase === 'response') && currentPart !== 5) || (isToeic&& (currentPart !== 1 && currentPart !== 3)) && currentPartQuestions.Questions[currentQuestionIndex].Description" v-html="currentPartQuestions.Questions[currentQuestionIndex].Description.replace(/(?:\r\n|\r|\n)/g, '<br/>')"></p>
          <p class="Title max-w-3xl mx-auto text-lg text-left"
            v-if="(!isToeic && currentPart !== 0 && currentPart !== 3 && currentPart !== 5 && isDirection)
                || (!isToeic && currentPart === 0 && !isDirection)
                || (!isToeic && currentPart === 2)
                || (!isToeic && currentPart === 3 && currentPhase !== 'direction')"
            v-html="currentPartQuestions.Questions[currentQuestionIndex].Title.replace(/(?:\r\n|\r|\n)/g, '<br/>')">
          </p>
          <div class="max-w-2xl mx-auto p-2 p-md-4" v-if="currentPartQuestions.Questions[currentQuestionIndex].ImageUrl && (isToeic || (!isToeic && currentPhase !== 'direction'))">
            <img :src="speakingData[currentPart].Questions[currentQuestionIndex]?.ImageUrl" alt=""  class="object-contain w-100 h-100">
          </div>
          <div class="max-w-2xl mx-auto p-2 p-md-4" v-if="currentPartQuestions?.stemInformationPic && (isToeic || (!isToeic && isDirection))">
            <img :src="currentPartQuestions.stemInformationPic" alt=""  class="object-contain w-100 h-100">
          </div>
        </div>
        <div class="speaking_inner d-flex justify-content-center flex-column" v-if="isFinish">
          <p class="text-2xl text-center">This is the end of the speaking test.</p>
          <p class="text-xl text-center">Your session is now complete.</p>
        </div>
        <div class="speaking_inner d-flex justify-content-center flex-column" v-if="currentPhase === 'isLoadingReport'">
          <p class="text-2xl text-center">Loading......</p>
        </div>
      </div>
    </div>
    <!-- buttons -->
    <a class="bg-blue-lighter-toeic text-white p-3 py-2 d-inline-block font-bold text-xl pointer" v-if="selectedStep === 0" @click="start_exam()">START</a>
    <!-- bridge說明階段 -->
    <div class="text-white text-xl d-flex flex-column" v-if="selectedStep === 1 && currentPhase === 'preContinue'">
      <div class="row mx-auto font-bold mb-2">
        <a class="bg-blue-lighter-toeic text-white p-3 py-2 d-inline-block font-bold text-xl pointer" @click="continue_exam()">Continue</a>
      </div>
    </div>
    <!-- 說明階段 -->
    <div class="text-white text-xl d-flex flex-column" v-if="selectedStep === 1 && isDirection">
      <div class="row mx-auto font-bold mb-2">
        <p class="bg-blue-lighter-toeic py-2 px-3 mb-0">DIRECTIONS</p>
        <p class="py-2 px-3 text-blue-main-toeic border-blue-main-toeic border mb-0">{{ formatSeconds(answer_count) }}</p>
      </div>
      <p class="text-blue-main-toeic" v-if="isToeic">The countdown will end and the question will begin</p>
    </div>
    <!-- 準備階段 -->
    <div class="text-white text-xl d-flex flex-column" v-if="selectedStep === 1 && currentPhase === 'prepare'">
      <div class="row mx-auto font-bold mb-2">
        <p class="bg-blue-lighter-toeic py-2 px-3 mb-0">PREPARATION TIME</p>
        <p class="py-2 px-3 text-blue-main-toeic border-blue-main-toeic border mb-0">{{ formatSeconds(answer_count) }}</p>
      </div>
      <p class="text-blue-main-toeic">Recording will start automatically after time</p>
    </div>
    <!-- 錄音階段 -->
    <div class="text-white text-xl d-flex flex-column" v-if="selectedStep === 1 && currentPhase === 'response'">
      <div class="row mx-auto font-bold mb-2">
        <div class="bg-blue-lighter-toeic d-flex align-items-center">
          <RecognitionS v-on:emitAudioData="emitAudioData" />
          <p class="bg-blue-lighter-toeic py-2 px-3 mb-0">RESPONSE TIME</p>
        </div>
        <p class="py-2 px-3 text-blue-main-toeic border-blue-main-toeic border mb-0">{{ formatSeconds(answer_count) }}</p>
      </div>
    </div>
    <!-- loading -->
    <div class="text-white text-xl d-flex flex-column" v-if="selectedStep === 1 && currentPhase === 'done'">
      <div class="row mx-auto font-bold mb-2">
        <div class="bg-blue-lighter-toeic loading p-3">
          <img :src="require('@/assets/image/toeic/toeic_exam/loading.png')" alt="" class="object-contain w-100 h-100 onreconation_icon">
        </div>
      </div>
    </div>
    <!-- finish -->
    <a class="bg-blue-lighter-toeic text-white p-3 py-2 d-inline-block font-bold text-xl pointer" v-if="isFinish" @click="getREPORT()">REPORT</a>
  </div>
</template>

<script>
  import Precautions from '@/components/AiHelper/toeic/precautions'
  import RecognitionS from '@/components/AiHelper/toeic/RecognitionS'
  import bridge_direction from '@/components/AiHelper/toeic/bridge_direction'
  import examJs from '@/components/AiHelper/examJs.js'
  export default {
    name: 'Speaking',
    props: {
      speakingData: {
        type: Array
      }
    },
    mixins: [
      examJs
    ],
    data () {
      return {
        selectedStep: 0,
        currentPart: 0,
        currentQuestionIndex: 0,

        currentPhase: 'direction', // 'preContinue' 'direction' | 'prepare' | 'response' | 'done' | 'finish' | 'allFinish' | 'isLoadingReport'

        answer_count: 5,
        timer: null,

        sound_effect: null,

        isPostingRecord: false,

        ctx: null,
        beep: {
          beep_duration: 0.3,
          beep_frequency: 1000,
          beep_volume: 0.8
        },
        exam_timers: [
          { index: 0,
            direction: 30,
            prepare: 0,
            times: [
              { num: 0, prepare: 45, response: 45, repeat: 1 },
              { num: 1, prepare: 45, response: 45, repeat: 1 }
            ]
          },
          { index: 1,
            direction: 30,
            prepare: 0,
            times: [
              { num: 2, prepare: 45, response: 30, repeat: 1 },
              { num: 3, prepare: 45, response: 30, repeat: 1 }
            ]
          },
          { index: 2,
            direction: 30,
            prepare: 0,
            times: [
              { num: 4, prepare: 3, response: 15, repeat: 1 },
              { num: 5, prepare: 3, response: 15, repeat: 1 },
              { num: 6, prepare: 3, response: 30, repeat: 1 }
            ]
          },
          { index: 3,
            direction: 30,
            prepare: 45,
            times: [
              { num: 7, prepare: 3, response: 15, repeat: 1 },
              { num: 8, prepare: 3, response: 15, repeat: 1 },
              { num: 9, prepare: 3, response: 30, repeat: 2 }
            ]
          },
          { index: 4,
            direction: 30,
            prepare: 0,
            times: [
              { prepare: 45, response: 60, repeat: 1 }
            ]
          }
        ],
        bridge_timers: [
          { index: 0,
            direction: 25,
            prepare: 0,
            times: [
              { num: 0, prepare: 25, response: 30, repeat: 1 },
              { num: 1, prepare: 25, response: 30, repeat: 1 }
            ]
          },
          { index: 1,
            direction: 25,
            prepare: 0,
            times: [
              { num: 2, prepare: 30, response: 30, repeat: 1 },
              { num: 3, prepare: 30, response: 30, repeat: 1 }
            ]
          },
          { index: 2,
            direction: 25,
            prepare: 0,
            times: [
              { num: 4, prepare: 15, response: 30, repeat: 1 }
            ]
          },
          { index: 3,
            direction: 25,
            prepare: 0,
            times: [
              { num: 5, prepare: 30, response: 30, repeat: 1 }
            ]
          },
          { index: 4,
            direction: 25,
            prepare: 0,
            times: [
              { num: 6, prepare: 45, response: 60, repeat: 1 }
            ]
          },
          { index: 5,
            direction: 25,
            prepare: 0,
            times: [
              { num: 7, prepare: 60, response: 60, repeat: 1 }
            ]
          }
        ]
      }
    },
    computed: {
      isToeic () {
        return this.$route.name === 'TOEIC_exam'
      },
      isDirection () {
        return this.currentPhase === 'direction'
      },
      isFinish () {
        return this.currentPhase === 'finish'
      },
      partTime () {
        if (this.isToeic) {
          return this.exam_timers[this.currentPart]
        }
        return this.bridge_timers[this.currentPart]
      },
      textLength () {
        return this.textVal ? this.textVal.replace(/[.,\/#!$%\^&\*;:{}=\-_`~()]/g, '').split(' ').filter(word => word.length > 0).length : 0
      },
      currentPartQuestions () {
        const partKeys = ['part1', 'part2', 'part3', 'part4', 'part5', 'part6']
        const key = partKeys[this.currentPart]
        return key ? this.getPartQuestions(key) : []
      },
      partMapping () {
        if (this.isToeic) {
          return {
            part1: ['朗讀'],
            part2: ['描述照片'],
            part3: ['回答問題'],
            part4: ['依據題目資料應答'],
            part5: ['陳述意見']
          }
        } else if (this.$route.name === 'TOEIC_bridge') {
          return {
            part1: ['短文朗讀'],
            part2: ['照片描述'],
            part3: ['主旨重述'],
            part4: ['簡短互動'],
            part5: ['故事描述'],
            part6: ['提議和支持論點']
          }
        }
        return {}
      }
    },
    components: {
      Precautions,
      RecognitionS,
      bridge_direction
    },
    beforeDestroy () {
      this.sound_effect ? this.audio_stop() : null
    },
    async mounted () {
      this.initTimers()
      if (!this.isToeic) {
        this.currentPhase = 'preContinue'
      }
      this.ctx = new (window.AudioContext || window.webkitAudioContext)()

      if (!this.$route.query.record_id) {
        this.$router.push({ name: 'Search'})
      }
    },
    methods: {
      async playBeep () {
        return new Promise(resolve => {
          const audioCtx = new (window.AudioContext || window.webkitAudioContext)()
          const oscillator = audioCtx.createOscillator()
          const gainNode = audioCtx.createGain()

          oscillator.type = 'sine'
          oscillator.frequency.setValueAtTime(this.beep.beep_frequency, audioCtx.currentTime) // 1000Hz = beep
          gainNode.gain.setValueAtTime(this.beep.beep_volume, audioCtx.currentTime) // 音量

          oscillator.connect(gainNode)
          gainNode.connect(audioCtx.destination)

          oscillator.start()
          oscillator.stop(audioCtx.currentTime + this.beep.beep_duration) // 0.3秒

          oscillator.onended = () => {
            audioCtx.close()
            resolve()
          }
        })
      },

      async initTimers () {
        if (!this.speakingData) return

        const isExam = this.isToeic
        const extra = isExam ? 0 : 0
        const targetTimers = isExam ? this.exam_timers : this.bridge_timers
        for (let i = 0; i < this.speakingData.length; i++) {
          const url = this.speakingData[i].DescriptionAudioUrl

          if (!url) {
            targetTimers[i].direction = extra
            console.warn(`題目 ${i + 1} 沒有音檔 URL，預設時間: ${extra}`)
            continue
          }

          try {
            const duration = await this.loadAudioDuration(url)
            targetTimers[i].direction = Math.ceil(duration + extra)
          } catch (err) {
            console.error(`題目 ${i + 1} 音檔載入失敗: ${url}`, err)
            targetTimers[i].direction = extra
          }
        }
      },

      getPartQuestions (partKey) {
        const targetNames = this.partMapping[partKey] || []
        return Array.isArray(this.speakingData)
          ? this.speakingData.find(el => targetNames.includes(el.Name?.trim()))
          : []
      },

      async start_exam () {
        this.selectedStep = 1
        if (this.isToeic) {
          if (this.currentPartQuestions.DescriptionAudioUrl) {
            await this.setAudio(this.currentPartQuestions.DescriptionAudioUrl)
          }
          this.answer_count = this.partTime.times[this.currentQuestionIndex].prepare
          this.startCountdown(this.partTime.direction, 'prepare', false)
        }
      },

      async continue_exam () {
        this.currentPhase = 'direction'
        if (this.currentPartQuestions.DescriptionAudioUrl) {
          await this.setAudio(this.currentPartQuestions.DescriptionAudioUrl)
        }

        let withBeep = this.$route.name === 'TOEIC_bridge' && this.currentPart !== 2 && this.currentPart !== 3 && this.currentPart !== 5 ? true : false

        this.startCountdown(this.partTime.direction, 'prepare', withBeep)
      },

      // step1
      startCountdown (duration, nextPhase, withBeep = false) {
        return new Promise(resolve => {
          this.selectedStep = 1
          this.answer_count = duration

          if (this.timer) clearInterval(this.timer)
          this.timer = setInterval(async() => {
            if (this.answer_count > 0) {
              this.answer_count--
            } else {
              clearInterval(this.timer)
              this.timer = null

              if (withBeep) {
                await this.playBeep()   // ✅ 倒數結束先 beep
              }
              if (nextPhase) this.nextPhase(nextPhase)

              resolve()
            }
          }, 1000)
        })
      },

      async nextPhase (phase) {
        this.currentPhase = phase
        // toeic
        if (this.isToeic) {
          if (this.currentPart === 3) {
            const stemInformationAudio = this.currentPartQuestions.stemInformationAudio
            this.answer_count = this.partTime.prepare
            stemInformationAudio ? await this.playAudioOnce(this.currentPartQuestions.stemInformationAudio) : null

            await this.startCountdown(this.partTime.prepare)

            this.currentQuestionIndex = 0
            this.answer_count = this.partTime.times[this.currentQuestionIndex].prepare
            await this.playAudioOnce(this.currentPartQuestions.Questions[this.currentQuestionIndex].AudioUrl)
            await this.startCountdown(this.partTime.times[this.currentQuestionIndex].prepare, null, true)

            this.currentPhase = 'response'
            await this.startCountdown(this.partTime.times[this.currentQuestionIndex].response)

            this.currentQuestionIndex = 1
            this.currentPhase = 'prepare'
            this.answer_count = this.partTime.times[this.currentQuestionIndex].prepare
            await this.playAudioOnce(this.currentPartQuestions.Questions[this.currentQuestionIndex].AudioUrl)
            await this.startCountdown(this.partTime.times[this.currentQuestionIndex].prepare, null, true)
            this.currentPhase = 'response'
            await this.startCountdown(this.partTime.times[this.currentQuestionIndex].response)

            this.currentQuestionIndex = 2
            this.currentPhase = 'prepare'
            this.answer_count = this.partTime.times[this.currentQuestionIndex].prepare
            await this.playAudioTwice(this.currentQuestionIndex)
            await this.startCountdown(this.partTime.times[this.currentQuestionIndex].prepare, null, true)
            this.currentPhase = 'response'
            await this.startCountdown(this.partTime.times[this.currentQuestionIndex].response)

            this.currentPhase = 'done'
            this.setPartQuestion()
          } else if (this.currentPart === 4) {
            this.currentQuestionIndex = 0
            this.answer_count = this.partTime.times[this.currentQuestionIndex].prepare
            await this.playAudioOnce(this.currentPartQuestions.Questions[this.currentQuestionIndex].AudioUrl, false)
            await this.startCountdown(45)
            this.currentPhase = 'response'
            await this.startCountdown(60)

            this.currentPhase = 'done'
            this.setPartQuestion()
          } else {
            if (phase === 'prepare') {
              const audioUrl = this.currentPartQuestions.Questions[this.currentQuestionIndex].AudioUrl
              const stemQuestionsAudio = this.currentPartQuestions.stemQuestionsAudio
              const prepareTime = this.partTime.times[this.currentQuestionIndex].prepare

              this.answer_count = prepareTime
              let withBeep = this.currentPart === 2 ? true : false

              if (stemQuestionsAudio && this.currentQuestionIndex === 0) {
                await this.playAudioOnce(this.currentPartQuestions.stemQuestionsAudio)
              }

              if (audioUrl) {
                this.setAudio2(audioUrl).then(async () => {
                  this.startCountdown(prepareTime, 'response', withBeep)
                })
              } else {
                this.startCountdown(prepareTime, 'response', withBeep)
              }

            } else if (phase === 'response') {
              this.startCountdown(this.partTime.times[this.currentQuestionIndex].response, 'done')
            } else if (phase === 'done') {
              this.setPartQuestion()
            }
          }
        }
        // bridge
        if (!this.isToeic) {
          if (this.currentPart === 2) {
            this.answer_count = this.partTime.times[this.currentQuestionIndex].prepare
            await this.playAudioOnce(this.currentPartQuestions.Questions[this.currentQuestionIndex].AudioUrl, true)
            this.currentPhase = 'prepare'
            await this.startCountdown(15, null, true)
            this.currentPhase = 'response'
            await this.startCountdown(30, null, false)

            this.currentPhase = 'done'
            this.setPartQuestion()
          } else if (this.currentPart === 3 || this.currentPart === 5) {
            this.answer_count = this.partTime.times[this.currentQuestionIndex].prepare
            await this.playAudioOnce(this.currentPartQuestions.Questions[this.currentQuestionIndex].AudioUrl, true)
            this.currentPhase = 'prepare'
            await this.startCountdown(this.partTime.times[this.currentQuestionIndex].prepare, null, true)
            this.currentPhase = 'response'
            await this.startCountdown(this.partTime.times[this.currentQuestionIndex].response, null, false)

            this.currentPhase = 'done'
            this.setPartQuestion()
          } else {
            if (phase === 'prepare') {
              const audioUrl = this.currentPartQuestions.Questions[this.currentQuestionIndex].AudioUrl
              const stemQuestionsAudio = this.currentPartQuestions.stemQuestionsAudio
              const prepareTime = this.partTime.times[this.currentQuestionIndex].prepare
              this.answer_count = prepareTime

              if (stemQuestionsAudio && this.currentQuestionIndex === 0) {
                await this.playAudioOnce(this.currentPartQuestions.stemQuestionsAudio)
              }
              if (audioUrl) {
                this.setAudio2(audioUrl).then(async () => {
                  if (this.currentQuestionIndex > 0) await this.playBeep()
                  await this.startCountdown(prepareTime, 'response', true)
                })
              } else {
                if (this.currentQuestionIndex > 0) await this.playBeep()
                await this.startCountdown(prepareTime, 'response', true)
              }
            } else if (phase === 'response') {
              // let isBeep = ((this.currentPart === 0 || 1) && this.currentQuestionIndex === 0)  ? true : false
              this.startCountdown(this.partTime.times[this.currentQuestionIndex].response, 'done', false)
            } else if (phase === 'done') {
              this.setPartQuestion()
            }
          }
        }
      },

      async setPartQuestion () {
        const isLastQuestion = this.currentQuestionIndex >= this.currentPartQuestions.Questions.length - 1
        const isLastPart = this.currentPart >= this.speakingData.length - 1

        if (!isLastQuestion) {
          // 還有下一題
          this.currentQuestionIndex++

          // 如果是 PART 4，題目間無準備時間，直接 response
          if (this.currentPart === 3 && this.isToeic) {
            this.nextPhase('response')
          } else {
            // 其他 PART 有準備時間
            await this.nextPhase('prepare')
          }

        } else if (isLastPart) {
          // 沒有下一 part，結束
          this.currentPhase = 'finish'

        } else {
          // 換下一個 part
          this.currentPart++
          this.currentQuestionIndex = 0
          this.currentPhase = 'direction'

          if (this.isToeic) {
            this.start_exam()
          } else {
            this.continue_exam()
          }
        }
      },

      // step2
      async emitAudioData (emitAudioData) {
        let self = this

        let result

        result = await self.post_assessments_records(this.$route.query.record_id, this.currentPartQuestions.Questions[self.currentQuestionIndex].Id, this.currentPartQuestions.Name, this.currentPartQuestions.Questions[this.currentQuestionIndex].Title, emitAudioData)

        if (result) {
        }
      },

      setAudio (url) {
        let self = this
        if (!url) return

        const loadAndPlay = () => {
          self.sound_effect = new Audio(url)

          // 播放音效
          if (self.currentPhase !== 'direction') {
            self.audio_play(self.partTime.times[self.currentQuestionIndex].repeat)
          } else {
            self.audio_play()
          }
        }

        if (self.sound_effect) {
          self.audio_stop().then(loadAndPlay)
        } else {
          loadAndPlay()
        }
      },

      setAudio2 (src) {
        return new Promise((resolve, reject) => {
          try {
            if (this.audio) {
              // 停止舊的
              this.audio.pause()
              this.audio.src = ''
              this.audio = null
            }

            const audio = new Audio(src)
            this.audio = audio

            audio.addEventListener('ended', () => {
              resolve() // 播放結束才 resolve
            })

            audio.addEventListener('error', (e) => {
              reject(e)
            })

            audio.play().catch(err => reject(err))
          } catch (err) {
            reject(err)
          }
        })
      },

      audio_play (times = 1) {
        let self = this
        let playCount = 0

        if (!self.sound_effect || times <= 0) return

        const onEnded = () => {
          playCount++
          if (playCount < times) {
            self.sound_effect.currentTime = 0
            self.sound_effect.play()
          } else {
            self.sound_effect.removeEventListener('ended', onEnded)
            self.audio_stop()
          }
        }

        self.sound_effect.addEventListener('ended', onEnded)
        self.sound_effect.play()
      },
      audio_stop () {
        let self = this
        return new Promise(resolve => {
          if (self.sound_effect) {
            self.sound_effect.pause()
            self.sound_effect.currentTime = 0
          }
          resolve()
        })
      },
      formatSeconds (seconds) {
        const mins = String(Math.floor(seconds / 60)).padStart(2, '0')
        const secs = String(seconds % 60).padStart(2, '0')
        return `${mins}:${secs}`
      },

      async getREPORT () {
        this.currentPhase = 'isLoadingReport'
        this.post_assessments_records_finish(this.$route.query.record_id)
      },

      playAudioOnce (url, withBeep = false) {
        return new Promise(resolve => {
          const audio = new Audio(url)
          audio.play()
          audio.onended = async () => {
            if (withBeep) {
              await this.playBeep()
            }
            resolve()
          }
        })
      },
      playAudioTwice(index) {
        return new Promise(resolve => {
          const audio = new Audio(this.currentPartQuestions.Questions[index].AudioUrl)
          let playCount = 0

          const play = () => {
            audio.currentTime = 0
            audio.play()
          }

          audio.onended = () => {
            playCount++
            if (playCount < 2) {
              play()
            } else {
              resolve()
            }
          }

          play()
        })
      },
      async loadAudioDuration (url) {
        return new Promise((resolve) => {
          const audio = new Audio()
          audio.src = url
          audio.addEventListener('loadedmetadata', () => {
            resolve(audio.duration)
          })
          audio.addEventListener('error', (url) => {
            console.warn('音檔載入失敗:', url)
            resolve(0) // 預設回傳 0，不會 throw
          })
        })
      }
    }
  }
</script>
<style lang="scss" scoped>
a {
  &:hover {
    text-decoration: none !important;
  }
}
.speaking_inner {
  min-height: calc(60vh);
}
.loading {
  width: 60px;
  height: 60px;
}
.onreconation_icon {
  transform: translate(-50%, -50%);
  animation: move 2s linear infinite;
  transform-origin: center;
}
@keyframes move {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
